import { fmtMoney } from "@/lib/format";

export function publicReceiptLink(orderId) {
  return `${window.location.origin}/r/${orderId}`;
}

export function buildReadyMessage(o, s) {
  const company = s?.company_name || "WuraPro";
  const cur = s?.currency || "KMF";
  const parts = [
    `Bonjour ${o.customer_name} 👋`,
    `Bonne nouvelle, votre commande ${o.order_number} est prête ! Vous pouvez venir la récupérer chez ${company}.`,
  ];
  if (o.remaining > 0) parts.push(`Reste à régler à la récupération : ${fmtMoney(o.remaining, cur)}.`);
  parts.push(`Merci de votre confiance 🙏`);
  if (s?.whatsapp) parts.push(`Contact : ${s.whatsapp}`);
  return parts.join("\n");
}

export function buildReceiptMessage(o, s, link) {
  const company = s?.company_name || "WuraPro";
  const cur = s?.currency || "KMF";
  const parts = [
    `${company} - Reçu ${o.order_number}`,
    `${o.customer_name}`,
    `Total ${fmtMoney(o.total, cur)} | Payé ${fmtMoney(o.paid, cur)} | Reste ${fmtMoney(o.remaining, cur)}`,
    `Statut : ${o.status}`,
  ];
  if (link) parts.push(`Détails : ${link}`);
  return parts.join("\n");
}

export function buildLoyaltyRewardMessage(c, s) {
  const company = s?.company_name || "WuraPro";
  const reward = c.reward_label || "votre récompense";
  const parts = [
    `Bonjour ${c.name} 🎉`,
    `Bonne nouvelle ! Vous avez une récompense fidélité disponible chez ${company} : ${reward}.`,
    `Passez la récupérer à la laverie. Merci de votre fidélité 🙏`,
  ];
  if (s?.whatsapp) parts.push(`Contact : ${s.whatsapp}`);
  return parts.join("\n");
}

export function openWhatsApp(phone, text) {
  const p = (phone || "").replace(/\D/g, "");
  window.open(`https://wa.me/${p}?text=${encodeURIComponent(text)}`, "_blank");
}

export function openSms(phone, text) {
  const p = (phone || "").replace(/[^\d+]/g, "");
  // `?body=` works on Android; iOS accepts `&body=`. Using `?body=` covers the common case.
  window.location.href = `sms:${p}?body=${encodeURIComponent(text)}`;
}
